// extracted by mini-css-extract-plugin
export default {"page":"UnsubscribePage_page__w25M+","title":"UnsubscribePage_title__LhGJd"};